// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Int from "../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as UseWindowSize$Showside from "./UseWindowSize.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as UseAnchorsType$Showside from "./UseAnchorsType.bs.js";
import * as ScrollDirection$Showside from "../utils/ScrollDirection.bs.js";
var memory = {
  contents: {}
};
function useDelayedRegister(hookResult, category) {
  var match = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var $$setTimeout = match.setTimeout;
  var match$1 = Belt_Option.getWithDefault(hookResult, UseAnchorsType$Showside.empty);
  var registerSection = match$1.registerSection;
  React.useEffect(function () {
    $$setTimeout(function (param) {
      Curry._1(registerSection, category);
    }, 0);
  }, []);
}
function useAnchors(enabledOpt, param) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var store = React.useRef([]);
  var scrollToRef = React.useRef(function (param) {});
  var highlightRef = React.useRef(function (param) {});
  var offset = React.useRef([]);
  var match = RouterProvider$Showside.useRouter(undefined);
  var listPageType = match.listPageType;
  var route = match.route;
  var setCurrentHighlightedCategoryId = React.useCallback(function (categoryId) {
    Curry._1(highlightRef.current, categoryId);
  }, [highlightRef]);
  var lockHighlightOnScroll = React.useRef(false);
  var match$1 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var lockHighlightOnScrollTimeout = match$1.setTimeout;
  var viewPLP;
  if (typeof route === "number") {
    viewPLP = false;
  } else {
    switch (route.TAG | 0) {
      case /* Home */0:
        var match$2 = route._0;
        viewPLP = Belt_Option.isSome(match$2.filters) || Belt_Option.isSome(match$2.sort);
        break;
      case /* ListPage */1:
        viewPLP = route._0.viewPLP;
        break;
      default:
        viewPLP = false;
    }
  }
  var getCurrentKey = function (param) {
    return Belt_Option.mapWithDefault(listPageType, "index", function (id) {
      if (typeof id === "number") {
        switch (id) {
          case /* Favorites */0:
            return "favorites";
          case /* History */1:
            return "history";
          case /* StoreCart */2:
            return "store-cart";
        }
      } else {
        switch (id.TAG | 0) {
          case /* Category */0:
            return "category-" + id._0;
          case /* Product */1:
            return "product-" + id._0;
          case /* StoreCategory */2:
            return "store-category-" + id._0.categoryId;
        }
      }
    }) + (viewPLP ? "-plp" : "-clp");
  };
  var getSectionElement = function (category) {
    return Caml_option.nullable_to_opt(document.querySelector("#sn-section-container-" + category.id + ""));
  };
  var getFromMemory = function (category) {
    return Belt_Array.getBy(store.current, function (data) {
      return data.id === category.id;
    });
  };
  var calculate = function (el, id, name) {
    var offsetTop = el.offsetTop;
    var __x = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(el.parentElement), el);
    var marginTop = Belt_Option.getWithDefault(Belt_Int.fromString(window.getComputedStyle(__x).marginTop), 0);
    var topDistance = offsetTop - marginTop | 0;
    return {
      id: id,
      el: el,
      topDistance: topDistance,
      name: name
    };
  };
  var recalculateAllWithId = function (id) {
    var fromMemory = Belt_Option.getWithDefault(Js_dict.get(memory.contents, id), []);
    var mod = Belt_Array.map(fromMemory, function (data) {
      return calculate(data.el, data.id, data.name);
    });
    memory.contents[id] = mod;
    if (getCurrentKey(undefined) === id) {
      store.current = mod;
      return;
    }
  };
  var recalculateOnZero = function (id) {
    var total = Belt_Array.reduce(store.current, 0, function (prev, curr) {
      return prev + curr.topDistance | 0;
    });
    if (total === 0) {
      return recalculateAllWithId(id);
    }
  };
  React.useEffect(function () {
    if (enabled) {
      var key = getCurrentKey(undefined);
      store.current = Belt_Option.getWithDefault(Js_dict.get(memory.contents, key), []);
      recalculateOnZero(key);
    }
  }, [listPageType, viewPLP]);
  UseWindowSize$Showside.useWindowResize(function (e) {
    if (enabled) {
      return recalculateAllWithId(getCurrentKey(undefined));
    }
  });
  var registerSectionByElement = React.useCallback(function (category) {
    return function (element) {
      if (!enabled) {
        return;
      }
      var data = Belt_SortArray.stableSortBy(Belt_Array.concat(Belt_Array.keep(store.current, function (t) {
        return t.id !== category.id;
      }), [calculate(element, category.id, category.title)]), function (a, b) {
        if (b.topDistance > a.topDistance) {
          return 1;
        } else {
          return -1;
        }
      });
      store.current = data;
      memory.contents[getCurrentKey(undefined)] = data;
    };
  }, [store, memory, route]);
  var registerSectionMaybe = React.useCallback(function (category) {
    if (!enabled) {
      return;
    }
    var el = getSectionElement(category);
    if (el !== undefined) {
      return Curry._2(registerSectionByElement, category, Caml_option.valFromOption(el));
    }
  }, [registerSectionByElement]);
  var lockHighlightOnScrollForOneSecond = React.useCallback(function (param) {
    lockHighlightOnScroll.current = true;
    ScrollDirection$Showside.Jammer.jam(undefined);
    lockHighlightOnScrollTimeout(function (param) {
      lockHighlightOnScroll.current = false;
      ScrollDirection$Showside.Jammer.unjam(undefined);
    }, 1000);
  }, [lockHighlightOnScroll]);
  var adjustTopDistance = function (topDistance) {
    return topDistance - Belt_Array.reduce(offset.current, 0, function (prev, curr) {
      return prev + curr | 0;
    }) | 0;
  };
  var previousEl = React.useRef(undefined);
  var onScrollElement = React.useCallback(function (el) {
    previousEl.current = previousEl.current === undefined ? el : previousEl.current;
    var isLocked = lockHighlightOnScroll.current;
    var isSameElement = Caml_obj.equal(el, previousEl.current);
    if (el === undefined) {
      return;
    }
    if (!(enabled && !isLocked && isSameElement)) {
      return;
    }
    var top = Caml_option.valFromOption(el).scrollTop | 0;
    Curry._1(setCurrentHighlightedCategoryId, Belt_Option.map(Belt_Array.getBy(store.current, function (data) {
      return top >= adjustTopDistance(data.topDistance);
    }), function (data) {
      return data.id;
    }));
  }, [store, lockHighlightOnScroll, enabled, setCurrentHighlightedCategoryId]);
  var onScrollDiv = React.useCallback(function (e) {
    return function (param) {
      return Curry._1(onScrollElement, e.target);
    };
  }, [onScrollElement]);
  var onScrollWindow = React.useCallback(function (e) {
    Curry._1(onScrollElement, Caml_option.nullable_to_opt(document.getElementsByTagName("html").item(0)));
  }, [onScrollElement]);
  var onClick = React.useCallback(function (category) {
    Curry._1(setCurrentHighlightedCategoryId, category.id);
    Curry._1(lockHighlightOnScrollForOneSecond, undefined);
    var memory = getFromMemory(category);
    var scrollToValue;
    if (memory !== undefined) {
      scrollToValue = {
        TAG: /* Pixel */1,
        _0: adjustTopDistance(memory.topDistance)
      };
    } else {
      var element = getSectionElement(category);
      if (element !== undefined) {
        var element$1 = Caml_option.valFromOption(element);
        Curry._2(registerSectionByElement, category, element$1);
        scrollToValue = {
          TAG: /* Element */0,
          _0: element$1
        };
      } else {
        scrollToValue = undefined;
      }
    }
    if (scrollToValue !== undefined) {
      Curry._1(scrollToRef.current, scrollToValue);
      return true;
    } else {
      return false;
    }
  }, [scrollToRef, registerSectionByElement]);
  var setOffset = function (newOffset) {
    offset.current = newOffset;
  };
  return React.useMemo(function () {
    return {
      anchors: store.current,
      offset: offset.current,
      registerSection: registerSectionMaybe,
      highlightRef: highlightRef,
      scrollToRef: scrollToRef,
      setOffset: setOffset,
      onScrollDiv: onScrollDiv,
      onScrollWindow: onScrollWindow,
      onClick: onClick
    };
  }, [store.current, offset.current, registerSectionMaybe, highlightRef, scrollToRef, onScrollDiv, onScrollWindow, onClick]);
}
export { memory, useDelayedRegister, useAnchors };
/* react Not a pure module */